export default __webpack_public_path__ + "static/media/logo-medlink-rgb.31be1294.svg";